import { types } from "mobx-state-tree"

export const CreateAcademicSession = types
    .model("CreateAcademicSession", {
        name: "",
        first_term: "",
        second_term: "",
        third_term: "",
    });
